import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import clsx from 'classnames';
import moment from 'moment';

//import { CALENDAR_EVENT_TYPE_IDS } from '../../libs/calendarConfig';
import { getUserAssignmentTypeDisplay } from '../../libs/user';

//- ui
import DateHeader from './DateHeader';
import Cell from './Cell';
import blueSemiTruckSvg from '../../images/calendar/blueSemiTruck.svg';
import unavailableSemiTruckSvg from '../../images/calendar/unavailableSemiTruck.svg';
import UnavailableTrucks from './Cells/UnavailableTrucks';
import UpdateWorkDayDialog from './UpdateWorkDayDialog';

// Updates the trucks in maintenance
import AddMaintenanceDialog from './MaintenanceAddDialog';
import UpdateMaintenanceDialog from './MaintenanceUpdateDialog';

import { statuses } from './WorkDayStatuses';
import { getNumberOfDaysBreakPoint } from '../../libs/calendarConfig';
import UpdateUserAssignmentDialog from './UpdateUserAssignmentDialog';
import AddUserAssignmentDialog from './AddUserAssignmentDialog';
import FleetCalendarRow from './Rows/FleetCalendarRow';
import { USER_TYPE_ENUM } from '../constants';

const isWorkingStatusMap = {};
statuses.forEach(({ value, isWorking }) => {
	if (isWorking) {
		isWorkingStatusMap[value] = true;
	}
});

function rgba(rgb, a) {
	const { r, g, b } = rgb;
	return `rgba(${r},${g},${b},${a})`;
}
const openColor = 'rgba(232, 245, 233,.6)';
const unavailableColor = 'rgba(255, 253, 231,.6)';
const groupColors = [
	{ r: 149, g: 117, b: 205 },
	{ r: 100, g: 181, b: 246 },
	{ r: 174, g: 213, b: 129 },
	{ r: 255, g: 183, b: 77 },
	{ r: 255, g: 138, b: 101 },
	{ r: 229, g: 115, b: 115 },
	{ r: 186, g: 104, b: 200 },
];

const styles = () => {
	return {
		tableContainer: {
			width: '100%',
			tableLayout: 'auto',
			display: 'table',
			borderSpacing: 0,
			borderCollapse: 'collapse',
		},
		blueSemiTruckIcon: {
			display: 'inline-block',
			width: 31,
			height: 33,
			backgroundImage: `url('${blueSemiTruckSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		unavailableSemiTruckIcon: {
			display: 'inline-block',
			width: 31,
			height: 33,
			backgroundImage: `url('${unavailableSemiTruckSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		openTruck: {
			margin: 5,
			whiteSpace: 'nowrap',
			fontWeight: 700,
			color: '#555',
		},
		openTruckCell: {
			backgroundColor: openColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'bottom',
		},
		openTruckCellHeader: {
			backgroundColor: openColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'middle',
		},
		unavailableTruck: {
			margin: 5,
			whiteSpace: 'nowrap',
			fontWeight: 700,
			color: '#555',
			display: 'flex',
			verticalAlign: 'middle',
			alignItems: 'center',
		},
		unavailableTruckCell: {
			backgroundColor: unavailableColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'top',
		},
		unavailableTruckCellHeader: {
			backgroundColor: unavailableColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'middle',
		},
		editHover: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			transition: '0.3s',
			cursor: 'pointer',
			border: '1px solid rgba(255,255,255,.1)',
			zIndex: 100,
			'&:hover': {
				border: '1px solid rgba(32,150,243,.8)',
				backgroundColor: `rgba(32,150,243,.2)`,
			},
		},
		topTotalRow: {
			borderTop: '2px solid #888',
		},

		totalCellHeader: {
			lineHeight: 1.3,
			textAlign: 'right',
			fontWeight: 500,
			color: '#444',
		},
		totalCell: {
			//backgroundColor : '#eff0f3',
			backgroundColor: '#eaf0f7',
			padding: `5px 10px`,
			borderBottom: '1px solid #bbb',
			verticalAlign: 'top',
		},
		topTotalRowNonDriver: {
			backgroundColor: '#d8e1ed',
		},

		totalRowExtraStats: {
			marginLeft: 10,
			fontSize: '90%',
		},
		driverCell: {
			padding: '4px 7px',
		},
		sortGroupCell: {
			border: `1px solid #bbb`,
			overflowX: 'hidden',
			height: 'auto',
			position: 'relative',
			padding: 10,
			//backgroundColor : '#D1C4E9',
			textTransform: 'uppercase',
			letterSpacing: 2,
			color: 'white',
			fontWeight: 500,
			fontSize: '13px',
		},
		slotOpen: {
			whiteSpace: 'noWrap',
			// backgroundColor : openColor,
			color: '#EA7416',
			fontSize: 14,
		},
		slotFull: {
			whiteSpace: 'noWrap',
			fontSize: 14,
		},
		subSlot: {
			fontSize: 12,
			color: '#666',
		},
		addButton: {
			fontSize: 12,
			marginLeft: 20,
			color: 'white',
			borderColor: `rgba(255, 255, 255, .7)`,
		},
	};
};

class FleetCalendarBody extends Component {
	constructor(props) {
		super(props);

		this.state = {
			userRows: [],
			workDayMap: {},
			openShiftDateMap: {},
			openTrucksByDate: {},

			workDayForUpdatingDialog: undefined,
			assignedLocationIdForDialog: undefined,
			assignedShiftTimeForDialog: undefined,
			isUpdatingDialogOpen: false,

			dateForAddMaintenance: undefined,
			assignDialogData: undefined,
			assignDialogIsOpen: false,
			addUserAssignmentDialogIsOpen: false,

			// maintenance
			isUpdatingMaintenanceDialogOpen: false,
			isAddingMaintenanceDialogOpen: false,
			openTrucksForDialog: undefined,
			unavailableTruckForDialog: undefined,
		};
	}

	static getDerivedStateFromProps(props) {
		const { searchResult = {}, userFilter, locationIds, shiftIds = [], userTypes = [] } = props;
		const { collections } = searchResult;

		const workDays = _.get(collections, 'workDayCollection', []);
		const openTrucks = _.get(collections, 'openTruckCollection', []);
		const unavailableTrucks = _.get(collections, 'unavailableTruckCollection', []);

		const userMap = _.keyBy(_.get(collections, 'userCollection', []), 'userId');
		const equipmentMap = _.keyBy(_.get(collections, 'equipmentCollection', []), 'equipmentId');

		const shiftMap = _.keyBy(_.get(collections, 'shiftCollection', []), 'shiftId');
		const locationMap = _.keyBy(_.get(collections, 'locationCollection', []), 'locationId');

		//- its a group because drivers could switch schedules mid segment
		// const userAssignmentGroups = _.groupBy(_.get('collections.userAssignmentCollection', []), 'userId');
		const userAssignments = _.get(collections, 'userAssignmentCollection', []);

		// Process the result
		const workDayMap = _.keyBy(workDays, 'workDayId');
		const userWorkDaysByDate = _.groupBy(workDays, 'date');
		const openTrucksByDate = _.groupBy(openTrucks, 'date');
		const openTruckMap = _.keyBy(openTrucks, 'openTruckId');
		const unavailableTrucksByDate = _.groupBy(unavailableTrucks, 'date');
		const unavailableTruckMap = _.keyBy(unavailableTrucks, 'unavailableTruckId');

		// const userGroups = _.groupBy(workDays, 'userId');

		const workDaysByUserAssignmentId = _.groupBy(workDays, 'userAssignmentId');

		/*
		const workDaysGroupedByUserAndShift = {};
		workDays.forEach((workDay) => {
			const { userAssignmentId } = workDay;
			const useShiftId = shiftId;

			const key = `${userAssignmentId}_${useShiftId}`;
			if (!workDaysGroupedByUserAndShift[key]) {
				workDaysGroupedByUserAndShift[key] = [];
			}
			workDaysGroupedByUserAndShift[userAssignmentId].push(workDay);
		});
		*/

		const showDrivers = _.includes(userTypes, USER_TYPE_ENUM.drivers);
		const showNonDrivers = _.includes(userTypes, USER_TYPE_ENUM.nonDrivers);

		const now = moment();
		const userRows = _.reduce(
			userAssignments,
			(acc, userAssignment) => {
				const {
					userAssignmentId,
					userId,
					locationId,
					endDate,
					userAssignmentTypeId,
					shiftId,
					shiftTime,
				} = userAssignment;

				if (!_.includes(locationIds, locationId)) {
					return acc;
				}

				if (endDate && moment(endDate).isBefore(now)) {
					return acc;
				}

				const user = userMap[userId] || { display: 'Missing' };

				if (!_.includes(shiftIds, shiftId)) {
					return acc;
				}

				// Don't show anything. Okay
				if (!showDrivers && !showNonDrivers) {
					return acc;
				}

				let showUser = false;

				if (showDrivers && showUser) {
					showUser = true;
				} else if (showDrivers && user.role === 'driver') {
					showUser = true;
				} else if (showNonDrivers && user.role !== 'driver') {
					showUser = true;
				}
				if (!showUser) {
					return acc;
				}

				// filtering
				if (_.isString(userFilter) && userFilter.length >= 3) {
					let hasMatch = false;
					let lc = userFilter.toLowerCase();

					if (user) {
						if (_.isString(user.lastName) && user.lastName.toLowerCase().includes(lc)) {
							hasMatch = true;
						}

						if (_.isString(user.firstName) && user.firstName.toLowerCase().includes(lc)) {
							hasMatch = true;
						}
					}

					if (!hasMatch) {
						return acc;
					}
				}

				//- Determine user and workDays
				const key = `${userAssignmentId}`;
				const workDaysForUser = workDaysByUserAssignmentId[key] || [];

				const userWorkDaysByDate = workDaysForUser.reduce((acc2, workDay) => {
					const date = workDay.date;
					if (!acc2[date]) {
						acc2[date] = [];
					}
					acc2[date].push(workDay);
					return acc2;
				}, {});

				const row = {
					key: `${userAssignmentId}_${shiftId}`,
					userAssignmentId,
					userAssignment,
					userAssignmentTypeId,
					locationId,
					shiftId,
					shiftTime,
					user,

					// sort
					truckNumber: user.display,
					userWorkDaysByDate,
				};
				acc.push(row);
				return acc;
			},
			[]
		);

		return {
			workDayMap,
			userRows: _.orderBy(userRows, ['userAssignmentTypeId', 'shiftTime', 'truckNumber']),
			userWorkDaysByDate,
			openTrucksByDate,
			openTruckMap,
			unavailableTrucksByDate,
			unavailableTruckMap,
			userMap,
			equipmentMap,
			shiftMap,
			locationMap,
		};
	}

	render() {
		const { classes, today, dateColumns, numberOfDays, locationIds, userTypes } = this.props;

		const showDrivers = _.includes(userTypes, USER_TYPE_ENUM.drivers);
		const showNonDrivers = _.includes(userTypes, USER_TYPE_ENUM.nonDrivers);

		const {
			unavailableTrucksByDate,
			userMap,
			equipmentMap,
			locationMap,
			shiftMap,
			isUpdatingDialogOpen,
			workDayForUpdatingDialog,
			assignedLocationIdForDialog,
			assignedShiftTimeForDialog,

			assignDialogIsOpen,
			assignDialogData,

			// Truck Maintenance
			isAddingMaintenanceDialogOpen,
			isUpdatingMaintenanceDialogOpen,
			unavailableTruckForDialog,
			dateForAddMaintenance,
			openTrucksForDialog,
		} = this.state;

		return (
			<Fragment>
				<table className={classes.tableContainer}>
					<thead>
						<DateHeader dateColumns={dateColumns} today={today} numberOfDays={numberOfDays} />
					</thead>
					<tbody>
						{this.renderTotalRow({ onlyDriversWorking: true, showDrivers, showNonDrivers })}
						{showDrivers ? (
							<tr>
								<Cell className={classes.unavailableTruckCellHeader} colSpan={2}>
									<div className={classes.unavailableTruck}>
										<div className={classes.unavailableSemiTruckIcon} />
										<div>Unavailable Trucks</div>
									</div>
								</Cell>

								{dateColumns.map(({ date }) => {
									const unavailableTrucks = unavailableTrucksByDate[date] || [];

									return (
										<UnavailableTrucks
											key={date}
											numberOfDays={numberOfDays}
											unavailableTrucks={unavailableTrucks}
											equipmentMap={equipmentMap}
											className={classes.unavailableTruckCell}
											onMaintenanceAdd={this.onMaintenanceAdd}
											onMaintenanceUpdate={this.onMaintenanceUpdate}
											date={date}
										/>
									);
								})}
							</tr>
						) : null}

						{this.renderRows()}
						{this.renderTotalRow({ showDrivers, showNonDrivers })}
					</tbody>
				</table>

				<UpdateWorkDayDialog
					open={isUpdatingDialogOpen}
					onClose={this.handleUpdateDialogClosed}
					onRefreshData={this.handleRefreshDataFromDialog}
					userMap={userMap}
					shiftMap={shiftMap}
					locationMap={locationMap}
					workDay={workDayForUpdatingDialog}
					assignedLocationId={assignedLocationIdForDialog}
					assignedShiftTime={assignedShiftTimeForDialog}
					openTrucks={openTrucksForDialog}
					locationIds={locationIds}
				/>

				<UpdateMaintenanceDialog
					open={isUpdatingMaintenanceDialogOpen}
					onClose={this.handleUpdateMaintenanceDialogClosed}
					onRefreshData={this.handleRefreshDataFromDialog}
					unavailableTruck={unavailableTruckForDialog}
					equipmentMap={equipmentMap}
					shiftMap={shiftMap}
				/>

				<AddMaintenanceDialog
					open={isAddingMaintenanceDialogOpen}
					date={dateForAddMaintenance}
					onClose={this.handleNewMaintenanceDialogClosed}
					onRefreshData={this.handleRefreshDataFromDialog}
				/>

				<UpdateUserAssignmentDialog
					open={assignDialogIsOpen}
					data={assignDialogData}
					onClose={this.handleAssignDialogClosed}
					onRefreshData={this.handleRefreshDataFromDialog}
				/>

				<AddUserAssignmentDialog
					open={this.state.addUserAssignmentDialogIsOpen}
					locationId={this.state.locationIdForAddUserAssignment}
					userAssignmentTypeId={this.state.userAssignmentTypeIdForAddUserAssignment}
					onClose={this.handleAddUserAssignmentDialogClose}
					onRefreshData={this.handleRefreshDataFromDialog}
				/>
			</Fragment>
		);
	}

	onWorkDayUpdate = ({ workDayId, assignedLocationId, assignedShiftTime }) => {
		const { showErrors } = this.props;
		const { workDayMap, openTrucksByDate } = this.state;
		const workDayForUpdatingDialog = workDayMap[workDayId];

		if (!workDayForUpdatingDialog) {
			return showErrors(`Missing workday for workDayId : ${workDayId}`);
		}

		const { date } = workDayForUpdatingDialog;
		const openTrucksForDialog = openTrucksByDate[date] || [];

		this.setState({
			workDayForUpdatingDialog,
			assignedLocationIdForDialog: assignedLocationId,
			assignedShiftTimeForDialog: assignedShiftTime,
			openTrucksForDialog,
			isUpdatingDialogOpen: true,
		});
	};

	handleUpdateDialogClosed = () => {
		this.setState({ isUpdatingDialogOpen: false });
	};

	updateUserAssignment = (assignDialogData) => {
		this.setState({
			assignDialogData,
			assignDialogIsOpen: true,
		});
	};
	handleAssignDialogClosed = () => {
		this.setState({ assignDialogIsOpen: false, assignDialogData: undefined });
	};

	// Add new assignment
	handleAddUserAssignment = ({ userAssignmentTypeId, locationId }) => {
		this.setState({
			addUserAssignmentDialogIsOpen: true,
			locationIdForAddUserAssignment: locationId,
			userAssignmentTypeIdForAddUserAssignment: userAssignmentTypeId,
		});
	};
	handleAddUserAssignmentDialogClose = () => {
		this.setState({
			addUserAssignmentDialogIsOpen: false,
			locationIdForAddUserAssignment: undefined,
			userAssignmentTypeIdForAddUserAssignment: undefined,
		});
	};

	//
	// Truck maintenance
	//
	onMaintenanceUpdate = ({ unavailableTruckId }) => {
		const { showErrors } = this.props;
		const { unavailableTruckMap } = this.state;

		const unavailableTruckForDialog = unavailableTruckMap[unavailableTruckId];
		if (!unavailableTruckForDialog) {
			return showErrors(`Missing unavailable truck for : ${unavailableTruckId}`);
		}

		this.setState({
			unavailableTruckForDialog,
			isUpdatingMaintenanceDialogOpen: true,
		});
	};

	handleUpdateMaintenanceDialogClosed = () => {
		this.setState({ isUpdatingMaintenanceDialogOpen: false });
	};

	//- Add new maintenance
	onMaintenanceAdd = ({ dateForAddMaintenance }) => {
		this.setState({
			dateForAddMaintenance,
			isAddingMaintenanceDialogOpen: true,
		});
	};
	handleNewMaintenanceDialogClosed = () => {
		this.setState({ isAddingMaintenanceDialogOpen: false });
	};

	//
	// Generic
	//
	handleRefreshDataFromDialog = () => {
		this.props.refreshCalendarData();
	};

	renderRows() {
		const { dateColumns, numberOfDays, classes } = this.props;
		const { userRows, userMap, shiftMap, locationMap } = this.state;

		if (_.isEmpty(userRows)) {
			return;
		}

		let lastTypeId;
		let currentGroupIndex = 0;

		return userRows.map((row, index) => {
			const {
				key,
				userAssignment,
				user,
				// activeUserAssignment,
				// inactiveUserAssignment,
				userAssignmentTypeId,
				locationId,
				//shiftId,
				shiftTime,

				// userAssignmentTypeId,
				// assignedLocationId,
				// assignedShiftTime,
				// userId,
				// userWorkDaysByDate,
			} = row;

			//- Used when sorting by terminal
			let sortRow = null;

			if (lastTypeId !== userAssignmentTypeId) {
				lastTypeId = userAssignmentTypeId;
				const color = groupColors[currentGroupIndex % groupColors.length];
				const style = {
					background:
						`linear-gradient(to right, ${rgba(color, 1)} 0%,` +
						`${rgba(color, 0.75)} 20%,` +
						`${rgba(color, 0)} 98%)`,
				};
				currentGroupIndex++;

				const scheduleDisplay = getUserAssignmentTypeDisplay({
					userAssignmentTypeId,
				});
				sortRow = (
					<tr key={'sortKey' + userAssignmentTypeId}>
						<td className={classes.sortGroupCell} style={style} colSpan={numberOfDays + 2}>
							<span>{scheduleDisplay}</span>
						</td>
					</tr>
				);
			}

			const isOdd = index % 2;
			return (
				<Fragment key={key}>
					{sortRow}
					<FleetCalendarRow
						row={row}
						dateColumns={dateColumns}
						numberOfDays={numberOfDays}
						userMap={userMap}
						shiftMap={shiftMap}
						locationMap={locationMap}
						isOdd={isOdd}
						updateUserAssignment={() => {
							this.updateUserAssignment({
								user,
								userAssignment,
							});
						}}
						onWorkDayUpdate={(workDayId) => {
							this.onWorkDayUpdate({
								workDayId,
								assignedLocationId: locationId,
								assignedShiftTime: shiftTime,
							});
						}}
					/>
				</Fragment>
			);
		});
	}

	renderTotalRow({ onlyDriversWorking = false, showDrivers, showNonDrivers }) {
		/** @namespace p.onlyTotals **/
		const { dateColumns, numberOfDays, classes } = this.props;

		const { userMap, userRows, userWorkDaysByDate, unavailableTrucksByDate } = this.state;

		if (_.isEmpty(userRows)) {
			return;
		}

		const driversWorkingRow = {
			label: 'Drivers Working',
			cellLabel: '',
			cells: [],
		};
		const driversEd = { label: 'Drivers on an ED', cellLabel: '', cells: [] };
		const driversOff = { label: 'Drivers Off', cellLabel: '', cells: [] };
		const unavailableTrucksRow = {
			label: 'Unavailable Trucks',
			cellLabel: '',
			cells: [],
		};

		const nonDriversWorkingRow = {
			isNonDriver: true,
			label: 'Non Drivers Working',
			cellLabel: '',
			cells: [],
		};

		const { nodIsSmall, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsSmall) {
			driversWorkingRow.cellLabel = 'Working';
			nonDriversWorkingRow.cellLabel = 'Working';
			driversEd.cellLabel = 'ED';
			driversOff.cellLabel = 'Off';

			unavailableTrucksRow.cellLabel = 'Unavailable';
		} else if (nodIsMedium) {
			driversWorkingRow.cellLabel = 'Work';
			nonDriversWorkingRow.cellLabel = 'Work';
			driversEd.cellLabel = 'ED';
			driversOff.cellLabel = 'Off';
			unavailableTrucksRow.cellLabel = 'Unavail';
		}

		dateColumns.forEach(({ date }) => {
			const workDays = userWorkDaysByDate[date] || [];

			//- Should never happen
			if (_.isEmpty(workDays)) {
				driversWorkingRow.cells.push({ content: '?' });
				nonDriversWorkingRow.cells.push({ content: '?' });
				driversEd.cells.push({ content: '?' });
				driversOff.cells.push({ content: '?' });
				unavailableTrucksRow.cells.push({ content: '?' });
			}
			let totalWorking = 0;
			let totalNonDriverWorking = 0;
			let totalEd = 0;
			let totalOff = 0;

			workDays.forEach((workDay) => {
				const { status, userId } = workDay;
				const user = userMap[userId] || { role: 'unknown' };
				if (user.role !== 'driver') {
					if (isWorkingStatusMap[status]) {
						totalNonDriverWorking++;
					}
					return;
				}

				if (isWorkingStatusMap[status]) {
					totalWorking++;
				}

				if (status === 'extraDay') {
					totalEd++;
				} else if (status === 'absent' || status === 'dayOff' || status === 'swapOff') {
					totalOff++;
				}
			});
			driversWorkingRow.cells.push({ content: totalWorking });
			nonDriversWorkingRow.cells.push({ content: totalNonDriverWorking });
			driversEd.cells.push({ content: totalEd });
			driversOff.cells.push({ content: totalOff });

			const totalUnavailable = unavailableTrucksByDate[date]
				? unavailableTrucksByDate[date].length
				: '0';

			unavailableTrucksRow.cells.push({ content: totalUnavailable });
		});

		const totalRows = [];

		if (onlyDriversWorking) {
			if (showDrivers) {
				totalRows.push(driversWorkingRow);
			}
			if (showNonDrivers) {
				totalRows.push(nonDriversWorkingRow);
			}
		} else {
			if (showDrivers) {
				totalRows.push(driversWorkingRow, driversEd, driversOff, unavailableTrucksRow);
			}
			if (showNonDrivers) {
				totalRows.push(nonDriversWorkingRow);
			}
		}

		return (
			<Fragment>
				{totalRows.map((row, i) => {
					const { label, cellLabel, cells, isNonDriver } = row;

					const cellClassNames = [classes.totalCell];
					if (i === 0) {
						if (!onlyDriversWorking) {
							cellClassNames.push(classes.topTotalRow);
						}
					}

					if (isNonDriver) {
						cellClassNames.push(classes.topTotalRowNonDriver);
					}

					return (
						<tr key={label}>
							<Cell
								className={clsx([classes.totalCellHeader, ...cellClassNames])}
								/// numberOfDays={numberOfDays}
								colSpan={2}
							>
								{label}
							</Cell>
							{cells.map(({ content }, j) => {
								return (
									<Cell className={clsx([cellClassNames])} numberOfDays={numberOfDays} key={j}>
										<strong>{content}</strong> {cellLabel}
									</Cell>
								);
							})}
						</tr>
					);
				})}
			</Fragment>
		);
	}
}

FleetCalendarBody.propTypes = {
	classes: PropTypes.object.isRequired,
	calendarType: PropTypes.oneOf(['users', 'trucks']),
	refreshCalendarData: PropTypes.func.isRequired,
	locationIds: PropTypes.array,
	userFilter: PropTypes.string,
	shiftIds: PropTypes.array,
	userTypes: PropTypes.array,
};
FleetCalendarBody.defaultProps = {
	calendarType: 'users',
};

export default _.flow([withStyles(styles)])(FleetCalendarBody);
